"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartController = void 0;
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("../../classes/appControllers/AppControllerBase");
const CartPosition_1 = require("../../classes/models/CartPosition");
const AppPM_1 = require("../AppPM");
class CartController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._cart = new Map();
        this._onCartChangedToken = new gs.EventGSToken();
        this.onCartChanged = new gs.EventGS(this._onCartChangedToken);
    }
    initialize() {
        this.reload();
        this._onCartChangedToken.invoke();
    }
    reload() {
        const json = localStorage.getItem(CartController.StorageName);
        if (!json) {
            AppPM_1.AppPM.GUI.setCartCount(0);
            return;
        }
        const cart = JSON.parse(json);
        this._cart.clear();
        for (const pos of cart)
            this._cart.set(pos.productId, pos);
        AppPM_1.AppPM.GUI.setCartCount(this._cart.size);
    }
    addProduct(id, count, weightKgPerLot) {
        if (count < 0)
            return;
        this.reload();
        if (this._cart.has(id)) {
            const obj = this._cart.get(id);
            if (obj)
                obj.count += count;
        }
        else
            this._cart.set(id, new CartPosition_1.CartPosition(id, count, weightKgPerLot));
        this._updateDB();
        this._onCartChangedToken.invoke();
    }
    removeProduct(id, count) {
        if (count < 0)
            return;
        this.reload();
        if (!this._cart.has(id))
            return;
        const pos = this._cart.get(id);
        if (pos) {
            pos.count -= count;
            if (pos.count <= 0)
                this._cart.delete(id);
        }
        this._updateDB();
        this._onCartChangedToken.invoke();
    }
    clear() {
        this._cart.clear();
        this._updateDB();
        this._onCartChangedToken.invoke();
    }
    isInCart(id) {
        return this._cart.has(id);
    }
    getCart() {
        return [...this._cart.values()];
    }
    getCartWeight() {
        let weightKg = 0;
        for (const w of this.getCart().map((p) => { return p.count * p.weightKgPerLot; }))
            weightKg += w;
        return weightKg;
    }
    getQty(id) {
        if (!this._cart.has(id))
            return 0;
        const obj = this._cart.get(id);
        if (!obj)
            return 0;
        return obj.count;
    }
    _updateDB() {
        AppPM_1.AppPM.GUI.setCartCount(this._cart.size);
        localStorage.setItem(CartController.StorageName, JSON.stringify(this.getCart()));
    }
}
exports.CartController = CartController;
CartController.StorageName = "cartProducts";
//# sourceMappingURL=CartController.js.map